module.exports = __webpack_public_path__ + "static/media/mobi xiao@2x.ab1a1eff.png";